import Header from '../Components/Header/Header';
import NavigationBar from '../Components/NavigationBar/NavigationBar.jsx';
import { Route, Routes, Navigate } from "react-router-dom";
import { useAuth } from './auth';
import LoginPage from './LoginPage.jsx';
import ProtectedRoute from './ProtectedRoute.jsx';
import Home from './Home';
import FuncArea from './FuncArea';
import Coursefaculty from './Coursefaculty';
import Faculty from './Faculty';
import TrngCourse from './TrngCourse';
import NeedsIdent from './NeedsIdent';
import SchedulePlanner from './SchedulePlanner';
import BatchStatus from './BatchStatus';
import UserForm from './UserForm';
import Attendance from './Attendance';
import Announcement from './Announcement';
import Report1 from './Report1';
import BatchDetails from './BatchDetails';
import EmployeeTrainingCompletion from './EmployeeTrainingCompletion';
import EmployeeTrainingIdentified from './EmployeeTrainingIdentified';
import TrainingBatchStatus from './TrainingBatchStatus';
import TrainingMatrixReport from './TrainingMatrixReport';
import ReportHome from './ReportHome';
import ReportLayout from './ReportLayout';
import Masters from './Masters';
import Training from './Training';
import FacultyViewer from '../Components/Viewers/FacultyViewer';
import TrainingManDaysCalculation from './TrainingManDaysCalculation';

function SURoute({ children }) {
  const { user } = useAuth();
  if (user?.role_code !== 'SU') return <Navigate to="/" replace />;
  return children;
}

export default function Tns() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />

      {/* Report routes — Header only, no NavBar */}
      <Route element={<ProtectedRoute />}>
        <Route element={<ReportLayout />}>
          <Route path="/reports/report1" element={<Report1 />} />
          <Route path="/reports/batch_details" element={<BatchDetails />} />
          <Route path="/reports/emp_trng_completion" element={<EmployeeTrainingCompletion />} />
          <Route path="/reports/emp_trng_ident" element={<EmployeeTrainingIdentified />} />
          <Route path="/reports/trng_man_hrs" element={<TrainingManDaysCalculation />} />
          <Route path="/reports/trng_batch_status" element={<TrainingBatchStatus />} />
          <Route path="/reports/trng_matrix" element={<TrainingMatrixReport />} />
        </Route>
      </Route>

      {/* All other routes — Header + NavBar */}
      <Route element={<ProtectedRoute />}>
        <Route path="/*" element={
          <div style={{ minWidth: "max-content" }}>
            <Header />
            <NavigationBar />
            <Routes>
              <Route index element={<Home />} />
              <Route path="/" element={<Home />} />
              <Route path="/training" element={<Training />} />
              <Route path="/reports" element={<ReportHome />} />
              <Route path="/training/scheduleplanner" element={<SchedulePlanner />} />
              <Route path="/training/needsident" element={<NeedsIdent />} />
              <Route path="/training/announcement" element={<Announcement />} />
              <Route path="/training/attendance" element={<Attendance />} />

              {/* Masters — SU only */}
              <Route path="/masters" element={<SURoute><Masters /></SURoute>} />
              <Route path="/masters/functionarea" element={<SURoute><FuncArea /></SURoute>} />
              <Route path="/masters/trngcourse" element={<SURoute><TrngCourse /></SURoute>} />
              <Route path="/masters/faculty" element={<SURoute><Faculty /></SURoute>} />
              <Route path="/masters/coursefaculty" element={<SURoute><Coursefaculty /></SURoute>} />
              <Route path="/masters/user" element={<SURoute><UserForm /></SURoute>} />
              <Route path="/masters/batchstatus" element={<SURoute><BatchStatus /></SURoute>} />
              <Route path="/masters/coursefaculty/facview" element={<SURoute><FacultyViewer /></SURoute>} />
            </Routes>
          </div>
        } />
      </Route>
    </Routes>
  );
}
